import { RTC_SFU_RECONNECTION_STATE } from "./rtc-sfu-reconnection-utils";

export function getRtcSfuConnectionNotification(state) {
  switch (state) {
    case RTC_SFU_RECONNECTION_STATE.RECONNECTING:
      return {
        level: "warning",
        title: "Connection interrupted",
        body: "Reconnecting...",
        timeout: 5000
      };
    case RTC_SFU_RECONNECTION_STATE.REALLOCATING:
      return {
        level: "warning",
        title: "Still reconnecting",
        body: "This may take a moment.",
        timeout: 5000
      };
    case RTC_SFU_RECONNECTION_STATE.PROVISIONING:
      return {
        level: "info",
        title: "Still reconnecting",
        body: "This may take a moment.",
        timeout: 7000
      };
    case RTC_SFU_RECONNECTION_STATE.FAILED:
      return {
        level: "error",
        title: "Connection lost",
        body: "We couldn't reconnect automatically. Refresh the page to try again.",
        timeout: 10000
      };
    default:
      return null;
  }
}
